export default __webpack_public_path__ + "static/media/loc_img_2.fd99e9d1.jpg";